module.exports = __webpack_public_path__ + "img/multiplier_8_win.a2d93d5b.png";